<app-breadcrumb></app-breadcrumb>

<report-geofence-his-list [listType]="DtgListType.list"></report-geofence-his-list>
